<template>
  <div class="main-content">
    <section class="section">
      <PageHeaderNoAction
        :isShow="isShow"
        :page="this"
      >
      <template slot="buttons">
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-primary legitRipple" @click="saveButtonClicked()">
              <i class="fas fa-caret-right mr-2"></i>{{$helper.getWord('Next')}}
            </button>
          </div>
          <div class="mt-3 mt-lg-0 mr-lg-3">
            <button type="button" class="btn btn-light legitRipple" @click="cancelBtnClick()">
              <i class="far fa-window-close mr-2"></i>{{$helper.getWord('cancel')}}
            </button>
          </div>
        </template>
      </PageHeaderNoAction>
      <div class="section-body">
        <div class="card">
          <div class="card-header">
            <h4>{{$helper.getWord('Form Detail')}}</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <MobileTextbox
                :title="$helper.getWord('Form name')+':'"
                wrapperclass='col-12'
                labelclass='col-12'
                inputclass='col-12'
                :className="'gstGroup'"
                v-model="formData.form_name"
                :readonly="isEdit"
              />

            </div>
            <div class="row">
              <div class="col-12">
                <div class="row">
                  <label class="col-form-label" :class="'col-12'">{{$helper.getWord('description')}}</label>
                  <div class="col-12">
                    <textarea
                      class="form-control"
                      v-model="formData.description"
                      rows="3"
                      style="min-height: 100px"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h4>{{$helper.getWord('Select Model')}}</h4>
          </div>
          <div class="card-body">
            <div class="row">
            <fbselectbox2
                wrapperclass='col-12'
                :fboptions="[{ id:formData.mb_form_table_id , text: formData.mb_form_table_name}]"
                :fbhidelabel="true"
                :ajaxurl="'/api/model_builder/getModelBuilders'"
                v-model="formData.mb_form_table_id"
              />
            </div>
          </div>
        </div>
   
      </div>
    </section>
    <!--Submit Model-->
    <div
      id="wfDiagramModal"
      class="modal fade so-alert-dialog in"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg bootstrap-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div id="graph"></div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <!--Submit Model-->
  </div>
</template>


<script>
import api from "@/api";
import { mapActions, mapGetters } from "vuex";
import helper from "@/vueHelper";
import config from "@/config";

export default {
  title: "",
  access_code: "IWF_NEW02",
  icon: "far fa-copy fa-fw",
  hidden: true,
  components: {},
  data() {
    return {
      componentkey: 0,
      lookups: {
      },
      isShow: null,
      gridId: "form01",
      formData: {
      },
      ticon: false,
      isEdit: true,
      old_mb_form_table_id:null
    };
  },
  created() {
    ////this.$route.meta.access_code = this.gridId;
    //helper.initFormGrid(this);
    if (window.innerWidth < window.innerHeight || window.innerWidth > 768) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }

      if(this.$route.params.id!=null&&this.$route.params.id!=""){
       this.$route.meta.title = helper.getWord("Change Form");
      }else{
        this.$route.meta.title = helper.getWord("new form");
      }

  },
  computed: {
    computedIcon() {
      if (this.icon == undefined) {
        return true;
      }

      return this.icon;
    },
  },
  updated() {
    if (window.innerWidth < window.innerHeight) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
  },
  methods: {
    ...mapActions("grid", [
      "actionResetGrid",
      "actionSetGrid",
      "actionRequest"
    ]),
    ...mapActions("filters", ["actionFindNow"]),
    cancelBtnClick(){
      this.$router.push("/Builder/FormBuilder/list");
    },
    saveButtonClicked(){
      helper.loading();
      api.request(
        this,
        "post",
        `/userBuildForm/${this.gridId}_save`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          Parameters: {
            id: this.$route.params.id,
            formData: this.formData,
            // deleteColumnList: this.deleteColumnList,
            // deleteTableList: this.deleteTableList,
          }
        },
        function(r) {
          this.$router.push("/Builder/FormBuilder/FormBuilder?ID=" + r.data.form_ID);

          // helper.clearData(this);
          // this.deleteColumnList=[];
          // this.deleteTableList=[];
          // this.$router.go(-1);
          // console.log(r);
          // window.open(
          // config.serverBase+"/formBuilder.html?ID=" +
          //  r.data.form_ID,
          //  "_blank"
          // );
          
        //this.$router.push({ query: Object.assign(this.$route.query, { new: r.data.form_ID }) })
        this.isEdit = true;
        this.$route.params.id = r.data.form_ID;
        },
        function(r) {
          helper.done();
        }
      );
    },

    loadForm() {
      helper.loading();
     
      api.request(
        this,
        "post",
        `/userBuildForm/${this.gridId}_load`,
        {
          SessionID: helper.getSessionID(),
          LocaleCode: helper.getLocaleCode(),
          //LocaleCode: this.$store.state.user.locale_code,
          Parameters: {
            id: this.$route.params.id
          }
        },
        function(r) {
          this.formData = r.data.formData;
           console.log(this.formData);
            this.old_mb_form_table_id= r.data.formData.mb_form_table_id;
          // console.log(this.formData.id);
          if (this.formData.id == '00000000-0000-0000-0000-000000000000') {
            this.isEdit = false;
          }
          helper.done();

        },
        function(r) {
          helper.done();
        },
        null
      );

    },
  },
  mounted() {
     this.loadForm();

  },
};
</script>

<style scoped>
.section-body {
  padding-top: 100px;
}
</style>
